// Filters for records with no value set; sent as a fieldId with no optionId.
export const NOT_ASSIGNED_OPTION = 'NOT_ASSIGNED';
